"use client";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/03-presenters/components/ui/tooltip";
import { H1 } from "@/03-presenters/components/ui/typography";
import { Portal } from "@radix-ui/react-tooltip";
import { cx } from "class-variance-authority";
import Image from "next/image";
import Link from "next/link";
type ExternalLink = {
  href: string;
  image: string;
  alt: string;
  width: number;
  height: number;
  toolTipImage?: string;
  showBg?: boolean;
};
const firstRowexternalLinkList = [{
  href: "https://erp.91miaoshou.com/?ac=18rou5",
  image: "/partner/miaoshoulogo.webp",
  toolTipImage: "/partner/miaoshoucard.webp",
  alt: "妙手",
  width: 204,
  height: 257
}, {
  href: "https://www.chwang.com/",
  image: "/partner/chuhaiwang.webp",
  alt: "出海网",
  width: 204,
  height: 257
}, {
  href: "https://www.cifnews.com/",
  image: "/partner/yuguokuajing.webp",
  alt: "雨果跨境",
  width: 180,
  height: 257
}, {
  href: "https://www.tt123.com/",
  image: "/partner/tt123.webp",
  alt: "TT123",
  width: 160,
  height: 257
}, {
  href: "https://www.tkfff.com/",
  image: "/partner/tkfff.webp",
  alt: "TKFFF",
  width: 160,
  height: 257
}, {
  href: "https://www.ziniao.com/?from=841007&utm_source=841007",
  image: "/partner/ziniao.webp",
  alt: "紫鸟",
  width: 160,
  height: 257
}, {
  href: "https://ai.linkfox.com/?channel=Becca_chuhaijiang",
  image: "/partner/linkfox.webp",
  alt: "Linkfox",
  width: 160,
  height: 257
}];
const secondRowexternalLinkList = [{
  href: "https://share.adspower.net/BDchuhaijiang",
  image: "/partner/adspower.svg",
  toolTipImage: "/partner/adspower.webp",
  alt: "Adspower",
  width: 204,
  height: 257
}, {
  href: "https://www.createseek.com/",
  image: "/partner/createseek.webp",
  alt: "随新索创",
  width: 204,
  height: 257
}, {
  href: "https://www.ipwo.net/?ref=chij",
  image: "/partner/ipwo.webp",
  toolTipImage: "/partner/ipwocard.webp",
  alt: "ipwo",
  width: 204,
  height: 257
}, {
  href: "https://www.superads.cn/",
  image: "/partner/superads.webp",
  alt: "线条科技",
  showBg: true,
  width: 204,
  height: 257
}, {
  href: "https://ny-gc.com",
  image: "/partner/ny-gc.webp",
  alt: "品牌方程式",
  width: 204,
  height: 257
}, {
  href: "https://www.wotohub.com/?channel_id=9326db&source_id=8132d6",
  image: "/partner/wotohub.webp",
  alt: "WotoHub",
  width: 204,
  height: 257
}, {
  href: "https://daohang.saiboyy.com/",
  image: "/partner/kuajingdaohang.webp",
  alt: "Saibo跨境导航",
  width: 204,
  height: 116.85
}];
const thirdRowexternalLinkList = [{
  href: "https://www.duoplus.cn/?r=chjiang",
  image: "/partner/duoplus.webp",
  toolTipImage: "/partner/duoplus_card.webp",
  alt: "duoplus",
  width: 204,
  height: 257
}, {
  href: "https://www.10100.com",
  image: "/partner/dashukuajing.webp",
  alt: "大数跨境",
  width: 160,
  height: 257
}, {
  href: "https://www.kookeey.com/?aff=71723763",
  image: "/partner/kookeey.webp",
  alt: "KooKeey",
  width: 160,
  height: 257
}, {
  href: "https://www.lycheeip.com/?affId=vKyrvipuZ6",
  image: "/partner/lycheeip.webp",
  alt: "荔枝IP",
  width: 160,
  height: 257
}, {
  href: "https://www.tkspmall.com/?affId=mkrPdPzJgm",
  image: "/partner/tkspmall.webp",
  alt: "跨境百宝箱",
  width: 160,
  height: 257
}, {
  href: "https://www.wahuto.com/",
  image: "/partner/wahuto.webp",
  toolTipImage: "/partner/wahuto_card.webp",
  alt: "Wahuto",
  width: 204,
  height: 257
}, {
  href: "https://blurpath.com?channel_code=tony",
  image: "/partner/blurpath.webp",
  toolTipImage: "/partner/blurpath_card.webp",
  alt: "Blurpath",
  width: 204,
  height: 257
}, {
  href: "https://academy.uniagency.net/",
  image: "/partner/taidong.webp",
  alt: "UniAgency",
  width: 204,
  height: 257
}, {
  href: "https://www.geelark.cn?invite_code=Ijo2vn&utm_source=useful-links&utm_medium=partner&utm_campaign=chuhaijiang&utm_id=GeeLark",
  image: "/partner/geelark.webp",
  alt: "GeeLark",
  width: 204,
  height: 257
}];
function MovingImage({
  externalLink,
  direction = "left"
}: {
  externalLink: React.ReactNode;
  direction?: "left" | "right";
}) {
  return <div className="mt-8 inline-flex w-fit" style={{
    animation: `scroll-${direction} 30s linear infinite`
  }} onMouseEnter={e => {
    e.currentTarget.style.animationPlayState = "paused";
  }} onMouseLeave={e => {
    e.currentTarget.style.animationPlayState = "running";
  }} data-sentry-component="MovingImage" data-sentry-source-file="Partner.tsx">
      {externalLink}
      {externalLink}
      {externalLink}
      {externalLink}
    </div>;
}
function generateExternalLink(externalLinkList: ExternalLink[]) {
  return externalLinkList.map(item => {
    if (item.toolTipImage) {
      return <Link key={item.href} href={item.href} target="_blank" className="mr-16 flex items-center">
          <TooltipLink content={<Image src={item.toolTipImage} alt={item.alt} width={204} height={257} className="h-auto" style={{
          maxHeight: "none",
          maxWidth: "none"
        }} />}>
            <div className="flex items-center justify-center">
              <Image src={item.image} alt={item.alt} width={item.width} height={item.height} className="h-auto" style={{
              maxHeight: "none",
              maxWidth: "none"
            }} />
            </div>
          </TooltipLink>
        </Link>;
    }
    return <Link key={item.href} href={item.href} target="_blank" className={cx("mr-16 flex items-center", item.showBg && "bg-black")}>
        <div className="flex items-center justify-center">
          <Image src={item.image} alt={item.alt} width={item.width} height={item.height} className="h-auto" style={{
          maxHeight: "none",
          maxWidth: "none"
        }} />
        </div>
      </Link>;
  });
}
export default function Partner() {
  const externalLink = generateExternalLink(firstRowexternalLinkList);
  const secondRowExternalLink = generateExternalLink(secondRowexternalLinkList);
  const thirdRowExternalLink = generateExternalLink(thirdRowexternalLinkList);
  return <div className="flex w-full flex-col items-center justify-center overflow-x-hidden bg-white py-12" data-sentry-component="Partner" data-sentry-source-file="Partner.tsx">
      <H1 className="text-black" data-sentry-element="H1" data-sentry-source-file="Partner.tsx">合作伙伴</H1>
      <div className="w-full">
        <MovingImage externalLink={externalLink} data-sentry-element="MovingImage" data-sentry-source-file="Partner.tsx" />
      </div>
      <div className="mt-4 w-full">
        <MovingImage externalLink={secondRowExternalLink} direction="right" data-sentry-element="MovingImage" data-sentry-source-file="Partner.tsx" />
      </div>
      <div className="mt-4 w-full">
        <MovingImage externalLink={thirdRowExternalLink} data-sentry-element="MovingImage" data-sentry-source-file="Partner.tsx" />
      </div>
    </div>;
}
function TooltipLink({
  children,
  content
}: {
  children: React.ReactNode;
  content: React.ReactNode;
}) {
  return <TooltipProvider delayDuration={100} data-sentry-element="TooltipProvider" data-sentry-component="TooltipLink" data-sentry-source-file="Partner.tsx">
      <Tooltip data-sentry-element="Tooltip" data-sentry-source-file="Partner.tsx">
        <TooltipTrigger asChild data-sentry-element="TooltipTrigger" data-sentry-source-file="Partner.tsx">{children}</TooltipTrigger>
        <Portal data-sentry-element="Portal" data-sentry-source-file="Partner.tsx">
          <TooltipContent className="p-0" data-sentry-element="TooltipContent" data-sentry-source-file="Partner.tsx">{content}</TooltipContent>
        </Portal>
      </Tooltip>
    </TooltipProvider>;
}